export const DEFAULT_IDENTIFIER_FORMAT = "urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress";
export const DEFAULT_WANT_ASSERTIONS_SIGNED = true;
